import { OnboardingContainer } from "@components/onboarding";
import { useLogError } from "@utils/error";
import React from "react";

export const UnexpectedErrorPage: React.FC<any> = ({
  exhibit,
  module,
  onBack,
  onSkip,
  company,
  contact,
  error,
  exitPath,
}) => {
  const { type: moduleType } = module ?? {};
  const { name, type } = exhibit ?? {};
  const logError = useLogError();

  React.useEffect(() => {
    logError(error ?? "Unexpected error occurred", {
      name,
      moduleType,
      exhibitType: type,
      moduleId: module?.id,
      exhibitId: exhibit?.id,
      companyId: company?.value,
      contactId: contact?.id,
      path: window.location.pathname,
    });
  }, []);

  return (
    <OnboardingContainer
      title={`:(`}
      subtitle={`Oops something went wrong.`}
      progress={0}
      exitPath={exitPath}
      onBack={onBack}
      onSubmit={onSkip}
      name="unexpected-error-form"
      isLoading={false}
      nextButtonText="Next"
    >
      <div className="">
        <div className="flex flex-col gap-3">
          <p className="">
            Don't worry, engineering is trying to fix it for you!
          </p>
          <p>Please pray for them &#128591;</p>
          <p>
            You can move along by clicking <b>Next</b> below
          </p>
        </div>
      </div>
    </OnboardingContainer>
  );
};
